import React from 'react';

const LinkExpired = () => {
    const containerStyle = {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        background: '#f2f2f2',
        fontFamily: 'Arial, sans-serif'
    };

    const boxStyle = {
        background: '#fff',
        padding: '40px',
        borderRadius: '8px',
        boxShadow: '0 0 10px rgba(0,0,0,0.1)',
        textAlign: 'center'
    };

    const headingStyle = {
        fontSize: '24px',
        marginBottom: '20px',
        color: '#333'
    };

    const descriptionStyle = {
        fontSize: '16px',
        color: '#555'
    };

    return (
        <div style={containerStyle}>
            <div style={boxStyle}>
                <h1 style={headingStyle}>הלינק אינו בתוקף</h1>
                <p style={descriptionStyle}>נא לפנות לתמיכה או לבקש לינק חדש</p>
            </div>
        </div>
    );
};

export default LinkExpired;
